import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const SettingsFieldsView = angular
  .module('acme.view.application.settings.fields', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.settings.fields.controllers',
    'acme.view.application.dataGrid.controllers',
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const settingsFields = {
      name: 'application.settings.fields',
      url: '/fields',
      views: {
        'subview-main': {
          controller: 'SettingsFieldsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/settings/fields/fields.tpl.html',
        },
      },
      data: {
        pageTitle: 'Custom Fields',
        permissions: ['CUSTOM_FIELDS_VIEW'],
        enablePreferences: true,
      },
    };

    $stateProvider.state(settingsFields);
  }).name;
